import { quantityValueToMetricTonnes } from "./formatNumbers";

const num = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
};

const qtyTonnesFromOffer = (offer) => {
    if (offer?.standard_available_quantity != null) {
        return num(offer.standard_available_quantity) / 1000;
    }
    const t = quantityValueToMetricTonnes(offer?.quantity, offer?.units ?? "kg");
    return Number.isFinite(t) ? t : 0;
};

export function computeTradeOfferStats(offers) {
    const list = Array.isArray(offers) ? offers : [];
    const byStatus = {};
    const byType = {};
    const cropStats = {};
    let totalValue = 0;
    let totalQtyTonnes = 0;
    let priceWeightedQtyTonnes = 0;
    let openOfferCount = 0;

    for (const o of list) {
        const status = String(o?.status || "UNKNOWN");
        const type = String(o?.offer_type || "UNKNOWN");
        byStatus[status] = (byStatus[status] || 0) + 1;
        byType[type] = (byType[type] || 0) + 1;

        const qtyT = qtyTonnesFromOffer(o);
        const qtyKg = qtyT * 1000;
        const price = num(o?.price);
        const value = qtyKg * price;
        const cropLabel = o?.crop?.name ?? o?.crop_name ?? `Crop #${o?.crop?.id ?? o?.crop ?? "—"}`;

        totalQtyTonnes += qtyT;
        totalValue += value;
        if (qtyT > 0 && price > 0) {
            priceWeightedQtyTonnes += qtyT;
        }
        if (status.toUpperCase() === "OPEN") {
            openOfferCount += 1;
        }

        if (!cropStats[cropLabel]) {
            cropStats[cropLabel] = {
                label: cropLabel,
                qtyTonnes: 0,
                value: 0,
            };
        }
        cropStats[cropLabel].qtyTonnes += qtyT;
        cropStats[cropLabel].value += value;
    }

    const cropMix = Object.values(cropStats).sort((a, b) => b.value - a.value);
    const averagePricePerKg = priceWeightedQtyTonnes > 0
        ? totalValue / (priceWeightedQtyTonnes * 1000)
        : 0;

    return {
        offerCount: list.length,
        openOfferCount,
        totalQtyTonnes,
        totalValue,
        averagePricePerKg,
        byStatus,
        byType,
        cropMix,
    };
}
